import { LoggerService } from "@commoncore/services/logger.service";
import * as CryptoJS from 'crypto-js';
import { AesUtilService } from "../../../app/core/services/aes-util.service";

//this class will encrypt all the strings
export class PasswordEncryptorUtil{
	public AESUtilRef: any;
	loggerService: LoggerService;

	constructor() {
		this.AESUtilRef= new AesUtilService();
		this.loggerService = new LoggerService;
	}

	public encryptPassword(password){
		var keySize = 128;
	    var iterationCount = 10000;
	    var iv = "F27D5C9927726BCEFE7510B1BDD3D137";
	    var passPhrase = "cyberSecurityHighAlert";
	    var encryptSalt  =  CryptoJS.enc.Hex.stringify(CryptoJS.lib.WordArray.random(128 / 4));
	    this.AESUtilRef.AesUtil(keySize,iterationCount);

	    this.loggerService.log(encryptSalt + this.AESUtilRef.encrypt(encryptSalt, iv, passPhrase,password))

		return encryptSalt + this.AESUtilRef.encrypt(encryptSalt, iv, passPhrase,password);
	}

	public encryptShareLinkPassword(password){
		var salt = "64";
 		var iv = "F27D5C9927726BCEFE7510B1BDD3D137";
 		var passphrase = "cyberSecurityHighAlert";
		var keySize = 128;
		var iterationCount = 10000;
		this.AESUtilRef.AesUtil(keySize,iterationCount);
		return this.AESUtilRef.encrypt(salt, iv, passphrase, password);
	}

	public decrypytSharePassPhrase(password){
		var salt = "64";
 		var iv = "F27D5C9927726BCEFE7510B1BDD3D137";
 		var passphrase = "cyberSecurityHighAlert";
		var keySize = 128;
		var iterationCount = 10000;
		this.AESUtilRef.AesUtil(keySize,iterationCount);
	  
	   return  this.AESUtilRef.decrypt(salt, iv, passphrase,password);
	}

	public getHash(key,msg){
		return this.AESUtilRef.getSHA256(key,msg);
	}

	public encryptPassPhrase(encryptionCode,StringToEncrypt){
		// var keySize = 128;
	    // var iterationCount = 10000;
		// var iv = "F27D5C9927726BCEFE7510B1BDD3D137";
		        
	    //var passPhrase = "cyberSecurityHighAlert";
		//var encryptSalt  = userId;// CryptoJS.enc.Hex.stringify(CryptoJS.lib.WordArray.random(128 / 4));
		//var encryptSalt  =  CryptoJS.enc.Hex.stringify(userId);

	   // this.AESUtilRef.AesUtil2();

		//this.loggerService.log(encryptSalt + this.AESUtilRef.encrypt(encryptSalt, iv, passPhrase,password))
		//this.loggerService.log(encryptSalt + this.AESUtilRef.encrypt3(passPhrase,password))
		
		// return  this.AESUtilRef.encrypt(encryptSalt, iv, passPhrase,password);
		return this.AESUtilRef.encrypt_PassPhrase(encryptionCode,StringToEncrypt);
	}

	public decryptTwoFASessionKey(encryptedTwoFASessionKey,twoFAHash){
		
		// var keySize = 128;
	    // var iterationCount = 10000;
	    // var iv = "F27D5C9927726BCEFE7510B1BDD3D137";
	    //var passPhrase = "cyberSecurityHighAlert";
	   // var encryptSalt  = userId;// CryptoJS.enc.Hex.stringify(CryptoJS.lib.WordArray.random(128 / 4));
		//this.AESUtilRef.AesUtil(keySize,iterationCount);
		//this.AESUtilRef.AesUtil2();

	   // this.loggerService.log(encryptSalt + this.AESUtilRef.encrypt(encryptSalt, iv, passPhrase,password))
	  
	   return  this.AESUtilRef.decrypt_PassPhrase(encryptedTwoFASessionKey,twoFAHash);
		//return  this.AESUtilRef.decrypt(encryptSalt, iv, passPhrase,password);
	}

/*
	public decrpytEnc2FAHash(twoFASessionKey,enc2FAHash){
		return  this.AESUtilRef.decrypt_PassPhrase(enc2FAHash,twoFASessionKey);
	}
*/
}